import React, { useState, useEffect } from "react";
import { Search, X, Minus, Plus, AlertCircle, Trash2 } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import ImageGallery from "./ImageGallery";
import { decryptData } from "../../../utils/storageCrypto";
const ViewMRitems = ({
  isOpen,
  onClose,
  MRDetails,
  MRitem,
  setMRItemsPoupMessage,
  setPopupType,
  fetchMrItems,
  setShowPopup,
}) => {
  const [pricingModel, setPricingModel] = useState("project");
  const [searchQuery, setSearchQuery] = useState("");
  const [items, setItems] = useState([]);
  const [originalItems, setOriginalItems] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [topAlert, setTopAlert] = useState(null);


  const fetchurl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

  // Fetch all products when popup opens
  useEffect(() => {
    if (isOpen) fetchAllItems();
  }, [isOpen]);

  console.log(MRitem)

  // Initialize MR data
  useEffect(() => {
    if (MRitem) {
      const pricing = MRitem.price_eligibility === "Project Pricing" ? "project" : "general";
      setPricingModel(pricing);

      const mappedItems = MRitem.items.map((item) => ({
        product_id: item.product_id?._id || item.product_id,
        name: item.product_name,
        quantity: item.quantity || 1,
        product_category_id: item.product_id?.product_category_id || item.product_category_id,
        UOM_id: item.UOM_id?._id || item.UOM_id,
        unit: item.unit || item.UOM_id?.UOM,
        image: item.product_id?.product_image
          ? `${imageurl}${item.product_id.product_image}`
          : null,
      }));
     console.log ('items mapped', mappedItems)
      setItems(mappedItems);
      setOriginalItems(JSON.parse(JSON.stringify(mappedItems)));
      setUnsavedChanges(false);
    }
  }, [MRitem, isOpen]);

  const fetchAllItems = async () => {
    try {
         const encryptedToken = sessionStorage.getItem('token');
             const token = decryptData(encryptedToken);
             const encryptedhubId = sessionStorage.getItem('hubId');
             const hubId = decryptData(encryptedhubId);
      if (!hubId) return console.error("hub ID not found.");

      const res = await fetch(
        `${fetchurl}product/get-all-products?hub_id=${hubId}`,
        {
          headers: { "Content-Type": "application/json", "x-token": token },
        }
      );
      const data = await res.json();
      if (data.success) setAllProducts(data.data);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  // Show top alert inside popup
  const showTopAlert = (message, type = "info") => {
    setTopAlert({ message, type });
    setTimeout(() => setTopAlert(null), 2500);
  };

  // Quantity change
 const handleQuantityChange = (id, value, index) => {
  setItems((prev) => {
    const newItems = [...prev];
    const item = newItems[index];
    console.log(item)
    if (!item) return prev;

    // If quantity is 1 and action is 'dec', show alert and remove the item
    if (item.quantity === 1 && value === "dec") {
      setTopAlert({
        message: `Quantity of "${item.name}" cannot be less than 1. Removing this item.`,
        onConfirm: () => {
          setTopAlert(null);
          setItems((current) => current.filter((_, i) => i !== index));
        },
      });
      return prev; // Do not immediately remove, wait for OK
    }
   
    // Otherwise, update the quantity
    newItems[index] = {
      ...item,
      quantity:
        typeof value === "number"
          ? Math.max(1, value) // Direct input: ensure min 1
          : value === "inc"
          ? item.quantity + 1 // Increment
          : Math.max(1, item.quantity - 1), // Decrement, min 1
    };

    return newItems;
  });

  setUnsavedChanges(true);
};


  // Add new item
  const handleAddItem = () => {
    const trimmed = searchQuery.trim();
    if (!trimmed) return showTopAlert("Enter a valid product name", "error");

    const found = allProducts.find(
      (p) => p.product_name.toLowerCase() === trimmed.toLowerCase()
    );

    const newItem = {
      name: found ? found.product_name : trimmed,
      product_id: found?._id,
      product_category_id: found?.product_category_id?._id,
      UOM_id: found?.UOM_id,
      unit: found?.UOM_id?.UOM || "Unit",
      image: found?.product_image ? `${imageurl}${found.product_image}` : null,
      quantity: 1,
      is_available: found ? true : false,
    };

    setItems((prev) => [...prev, newItem]);
    setSearchQuery("");
    setShowSuggestions(false);
    setUnsavedChanges(true);
    showTopAlert("Item added successfully!", "success");
  };

  // Save MR items
  const handleSaveItems = async () => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);

      const MR_Data = {
        _id:MRitem._id,
        material_requirement_id: MRDetails._id,
        price_eligibility:
          pricingModel === "project" ? "Project Pricing" : "General Pricing",
        product_category_ids: [
          ...new Set(items.map((i) => i.product_category_id)),
        ],
        items: items.map((i) => ({
          ...i,
          product_name: i.name,
        })),
      };

      const res = await fetch(
        `${fetchurl}customer/material-requirement/update-material-requirement-items`,
        {
          method: "POST",
          headers: { "x-token": token, "Content-Type": "application/json" },
          body: JSON.stringify({
            MRId: MRDetails._id,
            MR_items: MR_Data,
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setMRItemsPoupMessage(data.message);
        setPopupType("200or201");
        setShowPopup(true);
        fetchMrItems(MRDetails._id);
        setUnsavedChanges(false);
        setOriginalItems(JSON.parse(JSON.stringify(items)));
        onClose();
        showTopAlert("MR Items updated successfully!", "success");
      } else {
        showTopAlert("Failed to save items. Try again.", "error");
      }
    } catch (err) {
      console.error("Error saving items:", err);
      showTopAlert("Server error while saving items", "error");
    }
  };

  // Handle popup close with unsaved changes check
  const handleClose = () => {
  if (unsavedChanges) {
    setTopAlert({
      message: "You have unsaved changes. Closing will discard them.",
      onConfirm: () => {
        setTopAlert(null);
        setItems([]);  // discard changes
        setUnsavedChanges(false);
        onClose();      // close popup
      },
    });
    return;
  }
  //setItems([]);
  //setMRitem({})
  setUnsavedChanges(false);
  onClose();
};


  // Filter search suggestions
  const filteredProducts =
    allProducts.filter((item) =>
      item.product_name?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4 bg-black/40 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl w-full max-w-7xl max-h-[90vh] flex flex-col overflow-hidden shadow-2xl">
       
       {topAlert && (
  <TopAlert 
    message={topAlert.message} 
    onConfirm={topAlert.onConfirm} 
  />
)}


        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
          <h2 className="text-lg font-semibold text-gray-800">
            Material Requirement Items
          </h2>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-full transition"
          >
            <X size={20} className="text-gray-600" />
          </button>
        </div>

        {/* Main Content */}
        <div className="flex overflow-hidden">
          {/* Left Section */}
          <div className="w-1/2 flex items-center justify-center p-3 bg-gray-50">
            <ImageGallery attachments={MRDetails?.material_list_attachments || []} fetchurl={fetchurl} />
          </div>

          {/* Right Section */}
          <div className="w-1/2 flex flex-col bg-white px-8 py-5 overflow-hidden">
            {/* Pricing Type */}
            <div className="mb-6">
              <p className="text-sm font-semibold text-gray-800 mb-2">
                Select Pricing Type
              </p>
              <div className="flex gap-3">
                {["project", "general"].map((type) => (
                  <div
                    key={type}
                    className={`flex items-center gap-2 px-4 py-2 rounded-xl border transition-all cursor-pointer ${
                      pricingModel === type
                        ? "border-blue-600 bg-blue-50 shadow-sm"
                        : "border-gray-200 hover:border-gray-300"
                    }`}
                    onClick={() => {
                      setPricingModel(type);
                      setUnsavedChanges(true);
                    }}
                  >
                    <div
                      className={`w-3 h-3 rounded-full ${
                        pricingModel === type ? "bg-blue-600" : "bg-gray-300"
                      }`}
                    ></div>
                    <span
                      className={`text-sm font-medium ${
                        pricingModel === type
                          ? "text-blue-700"
                          : "text-gray-700"
                      }`}
                    >
                      {type === "project"
                        ? "Project Pricing"
                        : "General Pricing"}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Search + Add */}
            <div className="flex items-start gap-3 mb-4">
              <div className="relative flex-1">
                <Search
                  className="absolute left-3 top-3 text-gray-400"
                  size={18}
                />
                <input
                  type="text"
                  placeholder="Search or add an item..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setShowSuggestions(true);
                  }}
                  className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-xl outline-none focus:border-blue-400 text-sm transition"
                />
                {showSuggestions && searchQuery && (
                  <div className="absolute bg-white border border-gray-200 rounded-xl mt-1 w-full shadow-lg z-10 max-h-48 overflow-y-auto">
                    {filteredProducts.length > 0 ? (
                      filteredProducts.map((item) => (
                        <div
                          key={item._id}
                          onClick={() => {
                            setSearchQuery(item.product_name);
                            setShowSuggestions(false);
                          }}
                          className="px-4 py-2 hover:bg-blue-50 cursor-pointer text-sm text-gray-700"
                        >
                          {item.product_name}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-500">
                        No items found
                      </div>
                    )}
                  </div>
                )}
              </div>

              <button
  onClick={handleAddItem}
  className="text-sm font-medium py-2 px-4 rounded-md border border-[#f7525a] text-[#f7525a] bg-white hover:bg-[#f7525a] hover:text-white transition-colors duration-200 shadow-sm"
>
  Add
</button>

            </div>

            {/* Items List */}
            <div className="flex-1 overflow-y-auto mb-4 space-y-3">
              {items.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between border border-gray-100 rounded-xl p-3 hover:shadow-sm bg-white transition"
                >
                  <div className="flex items-center gap-3">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-10 h-10 rounded-md object-cover"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-md bg-gray-200 flex items-center justify-center">
                        <FontAwesomeIcon
                          icon={faImage}
                          className="text-gray-400"
                        />
                      </div>
                    )}
                    <span className="font-medium text-gray-800 text-sm">
                      {item.name}
                    </span>
                  </div>
                  {/* Right: QuantitySelector + Delete Button */}
             <div className="flex items-center gap-2">
                  <QuantitySelector
                    item={item}
                    quantity={item.quantity}
                    handleQuantityChange={handleQuantityChange}
                    index={index}
                  />
                   <button
                  onClick={() => {
                    setItems((prev) => prev.filter((_, i) => i !== index));
                    setUnsavedChanges(true); // Mark as unsaved changes
                  }}
                  className="p-2 hover:bg-red-50 rounded-full transition"
                  title="Remove item"
                >
                  <Trash2 className="w-4 h-4 text-red-500" />
                </button>
                </div>

                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 border-t pt-4 mt-auto">
              <button
                onClick={handleClose}
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition"
              >
                Cancel
              </button>
              {unsavedChanges && (
                <button
                  onClick={handleSaveItems}
                  className="px-5 py-2 text-sm font-medium border border-[#f7525a] text-[#f7525a] bg-white hover:bg-[#f7525a] hover:text-white transition-colors duration-200 rounded-lg shadow-sm transition"
                >
                  Update MR Items
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const QuantitySelector = ({ item, quantity, handleQuantityChange, min = 1, max = Infinity, index }) => {
  const [inputValue, setInputValue] = useState(quantity.toString());

  // Sync inputValue with quantity when quantity changes (e.g., from buttons)
  useEffect(() => {
    setInputValue(quantity.toString());
  }, [quantity]);

  // Handle input change (allow any typing, including clearing)
  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update local state freely
  };

  // Handle blur (validate and update parent)
  const handleInputBlur = () => {
    const numValue = parseInt(inputValue, 10);
    let finalValue;

    if (isNaN(numValue) || numValue < min) {
      finalValue = min; // Clamp to min if invalid or too low
    } else if (numValue > max) {
      finalValue = max; // Clamp to max if too high
    } else {
      finalValue = numValue; // Valid number
    }

    handleQuantityChange(item.id, finalValue, index); // Update parent
    setInputValue(finalValue.toString()); // Sync local state
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => handleQuantityChange(item.id, "dec", index)}
        className="w-7 h-7 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
      >
        <Minus size={14} />
      </button>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        className="w-12 text-center text-sm border border-gray-300 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-blue-500"
        min={min}
        max={max}
      />
      <button
        onClick={() => handleQuantityChange(item.id, "inc", index)}
        className="w-7 h-7 flex items-center justify-center border border-gray-300 rounded-full hover:bg-gray-100"
        disabled={quantity >= max}
      >
        <Plus size={14} />
      </button>
    </div>
  );
};


// Top Alert Component
const TopAlert = ({ message, onConfirm }) => {
  return (
    <div
      className="absolute top-4 left-1/2 transform -translate-x-1/2 px-4 py-3 rounded-lg border bg-gray-100 text-gray-800 border-gray-300 shadow-md flex items-center justify-between gap-4 w-[90%] max-w-lg z-50"
    >
      <span>{message}</span>
      <button
        onClick={onConfirm}
        className="px-3 py-1 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md text-sm font-medium transition"
      >
        OK
      </button>
    </div>
  );
};


export default ViewMRitems;
